import React, { useEffect, useState } from 'react';

import { useForm } from 'react-hook-form';
import { Button, Col, Form, Row } from 'react-bootstrap';
import * as countryList from '../../helper/country.json';
import { phoneNumberFormatter } from '../../utils/CheckoutUtils';
import { CustomToggleSubmit } from './CustomToggle';

export default function PersonalInformationForm({ personalInformation, setData }) {
  const [phoneNumber, setPhoneNumber] = useState('');

  const [countries, setCountries] = useState([]);

  useEffect(() => {
    setCountries(countryList.default);
  }, []);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      ...personalInformation,
    },
  });
  const submitButton = () => {
    if (!isValid) {
      return (
        <Button type="submit" className="btn-select mb-2">
          Continue
        </Button>
      );
    }
    return <CustomToggleSubmit eventKey="2">Continue</CustomToggleSubmit>;
  };
  const onSubmit = (data) => {
    setData(data);
  };
  return (
    <>
      <Form onSubmit={handleSubmit(onSubmit)} className="p-4">
        <Row>
          <Col sm={6}>
            <Form.Group className="mb-3" controlId="firstName">
              <Form.Control type="text" isInvalid={!!errors.firstName} placeholder="First Name" {...register('firstName', { required: true })} />
              {errors?.firstName?.type === 'required' && <p className="invalid-feedback">First Name is required</p>}
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group className="mb-3" controlId="lastName">
              <Form.Control type="text" isInvalid={!!errors.lastName} placeholder="Last Name" {...register('lastName', { required: true })} />
              {errors?.lastName?.type === 'required' && <p className="invalid-feedback">Last Name is required</p>}
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group className="mb-3" controlId="hotel-country">
              <Form.Select isInvalid={!!errors.country} placeholder="Country" {...register('country', { required: true })}>
                {countries.map((item) => {
                  return (
                    <option key={item.country_code_ppn} value={item.country_code_ppn} selected={item.country_code_ppn === 'US'}>
                      {item.country}
                    </option>
                  );
                })}
              </Form.Select>

              {errors?.country?.type === 'required' && <p className="invalid-feedback">Country is required</p>}
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group className="mb-3" controlId="hotel-state">
              <Form.Control type="text" isInvalid={!!errors.state} placeholder="State" {...register('state', { required: true })} />
              {errors?.state?.type === 'required' && <p className="invalid-feedback">State is required</p>}
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group className="mb-3" controlId="hotel-city">
              <Form.Control type="text" isInvalid={!!errors.city} placeholder="City" {...register('city', { required: true })} className="hotel-input-white" />
              {errors?.zipCode?.type === 'required' && <p className="invalid-feedback">City is required</p>}
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group className="mb-3" controlId="hotel-zipCode">
              <Form.Control type="text" isInvalid={!!errors.zipCode} placeholder="Billing Zip Code" {...register('zipCode', { required: true })} className="hotel-input-white" />
              {errors?.zipCode?.type === 'required' && <p className="invalid-feedback">Billing Zip Code is required</p>}
            </Form.Group>
          </Col>
          <Col xs={12}>
            <Form.Group className="mb-3" controlId="hotel-address">
              <Form.Control type="text" isInvalid={!!errors.address} placeholder="Address" {...register('address', { required: true })} className="hotel-input-white" />
              {errors?.address?.type === 'required' && <p className="invalid-feedback">Address is required</p>}
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group className="mb-3" controlId="hotel-email">
              <Form.Control type="text" isInvalid={!!errors.email} placeholder="Email" {...register('email', { required: true, pattern: /^\S+@\S+$/i })} className="hotel-input-white" />
              {errors?.email?.type === 'required' && <p className="invalid-feedback">Email is required</p>}
              {errors?.email?.type === 'pattern' && <p className="invalid-feedback">Email is valid email</p>}
            </Form.Group>
          </Col>
          <Col sm={6}>
            <Form.Group className="mb-3" controlId="hotel-phoneNumber">
              <Form.Control
                type="text"
                className="hotel-input-white"
                isInvalid={!!errors.phoneNumber}
                placeholder="Phone Number"
                {...register('phoneNumber', {
                  required: true,
                  onChange: (e) => {
                    const newValue = phoneNumberFormatter(phoneNumber, e.target.value);
                    setValue('phoneNumber', newValue, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                    setPhoneNumber(newValue);
                  },
                })}
              />
              {errors?.phoneNumber?.type === 'required' && <p className="invalid-feedback">Phone number is required</p>}
            </Form.Group>
          </Col>
        </Row>
        <div className="d-grid gap-2">{submitButton()}</div>
      </Form>
    </>
  );
}
